module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14y6pYN/tc-custom/9781681888064.jpg?1705208137624",
      "alt": "This image is the cover for the book Dad Jokes: Hall of Shame"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dad Jokes: Hall of Shame\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Over 1,000 gags and groaners to make you crack up and cringe at the same time!")]), _c('br'), _c('br'), _vm._v("From the creators of the popular humor website HowToBeADad.com, this is a collection of 1,000 of the most amusing—and most painful—Dad Jokes ever. Humor is often referred to as the best medicine, and this collection of Dad Jokes—guaranteed the most groan-and-forehead-slap-worthy on the market—offers a broad selection of humorous puns and quips. Organized by joke theme—from animals to holidays to technology—it includes more than a hundred illustrations, and even touches on some timely topics (“Because of the pandemic, they’re having to televise the World Origami Championship. It’s on paperview.”)\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andy Herald\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Andy Herald is a freelancer graphic designer, social media maven, parent of three excellently-parented kids (just ask him!), and the co-founder of HowToBeADad.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Weldon Owen\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0